// extracted by mini-css-extract-plugin
module.exports = {"groupStickerContainer":"GroupSticker_groupStickerContainer__3Ynkd","groupSticker":"GroupSticker_groupSticker__1-cJy"};